import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import ClientsAction from '../../../app/store/actions/clients';

class PunchoutUserIdentificationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enableParameters: false,
      form: {
        email: false,
        name: false,
        phone: false,
        unit: false,
      },
    };
  }

  componentDidMount() {
    const { item } = this.props.back.location;
    if (item) this.setFormInformation(item);
  }

  goBack = () => {
    this.props.back.goBack();
  }

  setFormInformation = (clientData) => {
    const { form } = this.state;
    let { enableParameters } = this.state;

    enableParameters = clientData.punchoutUserIndicatorParameters;
    form.email = clientData.punchoutUserIndicatorEmail;
    form.name = clientData.punchoutUserIndicatorName;
    form.phone = clientData.punchoutUserIndicatorPhone;
    form.unit = clientData.punchoutUserIndicatorUnit;

    this.setState({
      enableParameters,
      form,
    });
  }

  updateFormInformation = (formElementName) => {
    const { form } = this.state;

    if (formElementName === 'enableParameters') {
      this.setState((prevState) => {
        if (prevState.enableParameters === true) {
          return {
            enableParameters: !prevState.enableParameters,
            form: {
              email: false,
              name: false,
              phone: false,
              unit: false,
            },
          };
        }

        return {
          enableParameters: !prevState.enableParameters,
        };
      });
    } else {
      this.setState(prevState => ({
        form: {
          ...form,
          [formElementName]: !prevState.form[formElementName],
        },
      }));
    }
  }

  saveForm = async () => {
    const { enableParameters, form } = this.state;
    const { item } = this.props.back.location;

    const clientData = {
      clientId: item.clientId,
      punchoutUserIndicatorParameters: enableParameters,
      punchoutUserIndicatorEmail: form.email,
      punchoutUserIndicatorName: form.name,
      punchoutUserIndicatorPhone: form.phone,
      punchoutUserIndicatorUnit: form.unit,
    };

    try {
      await this.props.updateClient(clientData);

      await this.setState({
        successMessage: I18n.t('successActualized'),
        errorMessage: null,
      });
    } catch (error) {
      await this.setState({
        successMessage: null,
        errorMessage: I18n.t('errorOcurred'),
      });
    }
  }

  render() {
    const {
      enableParameters, form, successMessage, errorMessage,
    } = this.state;

    return (
      <form>
        <div className="form-group">
          <p className="margin-bottom-2">
            {`${I18n.t('enableParameters')} ?`}
          </p>
          <select
            required
            className="custom-select"
            value={enableParameters}
            onChange={() => this.updateFormInformation('enableParameters')}
          >
            <option value>{I18n.t('yes')}</option>
            <option value={false}>{I18n.t('no')}</option>
          </select>
        </div>
        <div className="row margin-bottom-20" style={{ marginTop: 10 }}>
          <div className="col-6">
            <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
              {I18n.t('selectRequiredParameters')}
            </p>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input checkbox-permissions"
                disabled={!enableParameters}
                checked={!!form.email}
                onChange={() => this.updateFormInformation('email')}
              />
              <p className="permission-text">
                <span className="permission-text">
                  {I18n.t('email')}
                </span>
              </p>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input checkbox-permissions"
                disabled={!enableParameters}
                checked={!!form.name}
                onChange={() => this.updateFormInformation('name')}
              />
              <p className="permission-text">
                <span className="permission-text">
                  {I18n.t('name')}
                </span>
              </p>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input checkbox-permissions"
                disabled={!enableParameters}
                checked={!!form.phone}
                onChange={() => this.updateFormInformation('phone')}
              />
              <p className="permission-text">
                <span className="permission-text">
                  {I18n.t('phone')}
                </span>
              </p>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input checkbox-permissions"
                disabled={!enableParameters}
                checked={!!form.unit}
                onChange={() => this.updateFormInformation('unit')}
              />
              <p className="permission-text">
                <span className="permission-text">
                  Unidade
                </span>
              </p>
            </div>
          </div>
        </div>
        {successMessage && (
          <p className="color-green margin-top-10">{successMessage}</p>
        )}
        {errorMessage && (
          <p className="color-red margin-top-10">{errorMessage}</p>
        )}
        <div className="row margin-left-0 margin-top-10">
          <button
            type="button"
            className="btn btn-warning margin-right-15"
            onClick={() => this.goBack()}
          >
            {I18n.t('return')}
          </button>
          <button
            type="button"
            className="btn btn-dark"
            onClick={() => this.saveForm()}
          >
            {I18n.t('save')}
          </button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  updateClient: clientData => dispatch(ClientsAction.updateClients(clientData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PunchoutUserIdentificationComponent);
